import { createAction } from '@reduxjs/toolkit';
import { createExtendedSlice } from '../createExtendedSlice';
import {
  RoutingAction,
  RoutingReducerState,
  RoutingSearchPayload,
} from './types';
import { SettingsRoutes } from 'src/routes';

const sliceName = 'routing';

// 4 state statuses (assets / snapshot):
// 1. undefined === initial
// 2. null === fetching
// 3. empty array === no data
// 4. array with items === with data
const initialState: RoutingReducerState = {};
// =============================
// ------- Slice ----------
// =============================
export const routingSlice = createExtendedSlice({
  name: sliceName,
  initialState,
  reducers: {},
});

// =============================
// ------- actions -------------
// =============================
export const routingOnRouteRequest = createAction<RoutingAction>(
  `${sliceName}/routingOnRouteToRequest`,
);
export const routingOnRoute = createAction<RoutingAction>(
  `${sliceName}/routingOnRouteTo`,
);
//
export const routingOnRouteToDashboard = createAction<RoutingSearchPayload>(
  `${sliceName}/routingOnRouteToDashboard`,
);
export const routingOnRouteToReceipts = createAction<RoutingSearchPayload>(
  `${sliceName}/routingOnRouteToReceipts`,
);
export const routingOnRouteToInbox = createAction<RoutingSearchPayload>(
  `${sliceName}/routingOnRouteToInbox`,
);
export const routingOnRouteToSettings = createAction<SettingsRoutes>(
  `${sliceName}/routingOnRouteToSettings`,
);
export const routingOnRouteToReports = createAction<RoutingSearchPayload>(
  `${sliceName}/routingOnRouteToReports`,
);

// =============================
// ------- Exports ----------
// =============================
export default routingSlice.reducer;
